module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ecommerce-slider donate-carousel",
    attrs: {
      "id": "ecommerce-slider"
    }
  }, [_c('VueSlickCarousel', _vm._b({
    staticClass: "slides-container"
  }, 'VueSlickCarousel', _vm.settings, false), _vm._l((_vm.images), function(image, i) {
    return _c('div', {
      key: i,
      staticClass: "product-slide",
      class: i > 0 ? 'slide-sub' : 'slide-main'
    }, [_c('img', {
      attrs: {
        "src": image,
        "alt": "product"
      }
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fac4a766","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/ecommerce/EcommerceSlider.vue
// module id = 867
// module chunks = 0